import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';


export async function getVipData() {
    const docRef = doc(db, 'grupVIP', 'dateGrup');
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        return docSnap.data();
    } else {
        return [];
    }
}